import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { VerticalsComponent } from './verticals/verticals.component';
import { ClientsComponent } from './clients/clients.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CustomSoftwareDevelopmentComponent } from './services/custom-software-development/custom-software-development.component';
import { WebDevelopmentComponent } from './services/web-development/web-development.component';
import { MobileDevelopmentComponent } from './services/mobile-development/mobile-development.component';
import { WebHostingComponent } from './services/web-hosting/web-hosting.component';
import { MaintenanceComponent } from './services/maintenance/maintenance.component';
import { UploadCvComponent } from './careers/upload-cv/upload-cv.component';
import { AbstractComponent } from './clients/abstract/abstract.component';
import { LoginComponent } from './login/login.component';
import { OurProductsComponent } from './our-products/our-products.component';
import { ProductDetailsComponent } from './our-products/product-details/product-details.component';
import { MultiBrandScrewAirComponent } from './verticals/multi-brand-screw-air/multi-brand-screw-air.component';
import { MultiBrandPistonComponent } from './verticals/multi-brand-piston/multi-brand-piston.component';
import { MultiBrandAirDryerComponent } from './verticals/multi-brand-air-dryer/multi-brand-air-dryer.component';
import { MultiBrandWaterChillerComponent } from './verticals/multi-brand-water-chiller/multi-brand-water-chiller.component';
import { MultiBrandOilChillerComponent } from './verticals/multi-brand-oil-chiller/multi-brand-oil-chiller.component';
import { PanelAirCoolerComponent } from './verticals/panel-air-cooler/panel-air-cooler.component';
import { AirPipeLineComponent } from './air-pipe-line/air-pipe-line.component';
import { ScrewAirCompressorComponent } from './our-products/screw-air-compressor/screw-air-compressor.component';
import { PistonAirCompressorComponent } from './our-products/piston-air-compressor/piston-air-compressor.component';
import { AirDryerComponent } from './our-products/air-dryer/air-dryer.component';
import { AirReceiverTankComponent } from './our-products/air-receiver-tank/air-receiver-tank.component';
import { WaterChillerComponent } from './our-products/water-chiller/water-chiller.component';
import { OilChillerComponent } from './our-products/oil-chiller/oil-chiller.component';
import { AirAccessoriesComponent } from './our-products/air-accessories/air-accessories.component';


const routes: Routes = [
  { path:'',component: HomePageComponent},
  { path:'home-page',component:HomePageComponent},
  { path:'about-us',component:AboutUsComponent},
  { path:'custom-software-development',component:CustomSoftwareDevelopmentComponent},
  { path:'web-development',component:WebDevelopmentComponent},
  { path:'mobile-development',component:MobileDevelopmentComponent},
  { path:'web-hosting',component:WebHostingComponent},
  { path:'maintenance',component:MaintenanceComponent},
  { path:'verticals',component:VerticalsComponent},
  { path:'clients',component:ClientsComponent},
  { path:'testimonials',component:TestimonialsComponent},
  { path:'upload-cv',component: UploadCvComponent},
  { path:'contact-us',component: ContactUsComponent},
  { path:'child-abstract/:data',component: AbstractComponent},
  { path: 'login' ,component: LoginComponent},
  { path:'ourproducts', component: OurProductsComponent},
  { path:'child-productdetails/:data',component: ProductDetailsComponent},
  { path: 'screw-air-compressor', component: MultiBrandScrewAirComponent},
  { path: 'piston-compressor', component: MultiBrandPistonComponent},
  { path: 'air-dryer', component: MultiBrandAirDryerComponent},
  { path: 'water-chiller', component: MultiBrandWaterChillerComponent },
  { path: 'oil-chiller', component: MultiBrandOilChillerComponent},
  { path: 'panel-air-cooler', component: PanelAirCoolerComponent },
  { path: 'air-pipe-line', component: AirPipeLineComponent },
  { path: 'screw', component: ScrewAirCompressorComponent},
  { path: 'piston',component: PistonAirCompressorComponent},
  { path: 'airdryer', component: AirDryerComponent},
  { path: 'airtank', component: AirReceiverTankComponent},
  { path: 'waterchiller', component: WaterChillerComponent},
  { path: 'oilchiller',component:OilChillerComponent},
  { path: 'airaccessories', component: AirAccessoriesComponent},



];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
